import { Typography } from '../../../../shared/view/components/Typography/Typography';

type TitleProps = {
  text: string;
};

export const ScreenTitle = ({ text }: TitleProps) => {
  return <Typography.Title className="w-full">{text}</Typography.Title>;
};
